import { useCallback } from 'react';
import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';

export const useSetCampaignName = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (name: string) => {
      dispatch({ type: 'SET_CAMPAIGN_NAME', payload: { name } });
    },
    [dispatch],
  );
};
